import { MenuItem } from "@/hooks/useMenu";
import { ProductItem } from "./ProductItem";
import { cn } from "@/lib/utils";
import { useCartStore } from "@/store/CartStore";

function ProductList({
  className = "",
  products = [],
}: {
  className?: string;
  products: MenuItem[];
}) {
  const { cart } = useCartStore();

  const productsFiltered = products.sort((a, b) => {
    if (a.unavailable && !b.unavailable) return 1;
    if (!a.unavailable && b.unavailable) return -1;
    return 0;
  });

  return (
    <div
      className={cn(
        "grid grid-cols-1 md:gap-4 max-md:divide-y max-md:divide-border lg:grid-cols-2",
        className
      )}
    >
      {productsFiltered.map((item) => {
        const itemsInCart = cart.filter(
          (cartItem) => cartItem.productId === item.id
        );

        if (itemsInCart.length > 0) {
          return itemsInCart.map((cartItem) => {
            return (
              <div
                key={cartItem.lineId}
                className="flex flex-col gap-y-0 h-full relative"
              >
                <ProductItem
                  item={item as MenuItem}
                  cartItem={cartItem}
                  key={cartItem.lineId + cartItem.id}
                />
              </div>
            );
          });
        }

        return (
          <div
            key={item.id}
            className="flex flex-col gap-y-0 md:border-t first:border-none [&:nth-child(2)]:border-none h-full"
          >
            <ProductItem item={item as MenuItem} />
          </div>
        );
      })}
    </div>
  );
}

export { ProductList };
